import { BarcodeScanModalBase } from '@components/BarCodeScanModal/Modals/BarcodeScanModalBase'
import { BarcodeScanModalProps } from '@components/BarCodeScanModal/types'
import { PrimaryButton } from '@components/core/Button'
import { getCustomizableBrand } from '@libs/custom'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useSendUnavailablePolirizedAnalyticsEvent } from './analytics'

export const BarcodeScanModalUnavailablePolarized = ({
  visible,
  onCancel,
  productInfo,
}: BarcodeScanModalProps) => {
  const { t } = useTranslation()
  const { originalBrandCode, thumbnails, customizable } = productInfo
  const formattedBrand = getCustomizableBrand(originalBrandCode)

  const subtitle = t('BarCodeScanModal.StandardSameModelSubtitle')
  const title = t('BarCodeScanModal.FindOutPolarizedVersion')
  const { sendDiscoverEvent } = useSendUnavailablePolirizedAnalyticsEvent(visible)

  const handleOnCancel = useCallback(() => {
    sendDiscoverEvent()
    onCancel()
  }, [onCancel, sendDiscoverEvent])

  return (
    <BarcodeScanModalBase
      visible={visible}
      title={title}
      titleWeight="bold"
      subtitle={subtitle}
      description={''}
      customizable={customizable}
      formattedBrand={formattedBrand}
      thumbnails={thumbnails}
      onCancel={handleOnCancel}
      footerContent={[
        <PrimaryButton key="cancel" onClick={handleOnCancel}>
          {t('BarCodeScanModal.DiscoverPolarized')}
        </PrimaryButton>,
      ]}
    />
  )
}
